import React, { Suspense, lazy } from "react"
import { Router, Switch, Route, Redirect } from "react-router-dom"
import { history } from "./history"
import { connect } from "react-redux"
import Spinner from "./components/@vuexy/spinner/Loading-spinner"
import { ContextLayout } from "./utility/context/Layout"
import navigationConfig from "./configs/menuConfig"
import Calendar from "./components/calendar/Calendar"
import { isMobile } from 'react-device-detect';
import MobileLayout from "./layouts/MobileLayout"

// Route-based code splitting
const Home = lazy(() =>
  import("./views/pages/Home")
)

const Page2 = lazy(() =>
  import("./views/pages/Page2")
)

const login = lazy(() =>
  import("./views/pages/authentication/Login")
)

const appointmentIframe = lazy(() =>
  import("./views/pages/iframe/Appointment")
)
const bookingIframe = lazy(() =>
  import("./views/pages/booking/Booking")
)
const giftCard = lazy(() =>
  import("./views/pages/giftcard/Giftcard.js")
)



// Set Layout and Component Using App Route
const RouteConfig = ({
  component: Component,
  fullLayout,
  noLayout,
  permission,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (noLayout === true) {
        return <Suspense fallback={<Spinner />}>
          <Component {...props} />
        </Suspense>
      }

      return (
        <ContextLayout.Consumer>
          {context => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === "horizontal"
                  ? context.horizontalLayout
                  : context.VerticalLayout
            return isMobile ? (
              <Suspense fallback={<Spinner />}>
                <MobileLayout>
                  <Component {...props} />
                </MobileLayout>
              </Suspense>
            )
              : (
                <LayoutTag {...props} permission={props.user}>
                  <Suspense fallback={<Spinner />}>
                    <Component {...props} />
                  </Suspense>
                </LayoutTag>
              )
          }}
        </ContextLayout.Consumer>
      )
    }}
  />
)
const mapStateToProps = state => {
  return {
    //user: state.auth.login.userRole
    user: 'admin'
  }
}

const AppRoute = connect(mapStateToProps)(RouteConfig)

class AppRouter extends React.Component {
  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Switch>
          <AppRoute exact path="/home" component={Home} />
          {navigationConfig.map(({ id, navLink, component }, index) => {
            return (
              <AppRoute key={id} exact path={navLink} component={component} />
            )
          })}
          <AppRoute exact path="/test" component={Calendar} />
          <Route exact path="/member">
            <Redirect to="/" />
          </Route>
          <AppRoute exact path="/" component={login} fullLayout />
          <AppRoute exact path="/appointment" component={appointmentIframe} noLayout />
          <AppRoute exact path="/booking" component={bookingIframe} noLayout />
          <AppRoute exact path="/giftcard" component={giftCard} noLayout />
        </Switch>
      </Router>
    )
  }
}

export default AppRouter
